/**
 * Enum for playlist repeat values.
 * @readonly
 * @enum {number}
 */
const PLAYLIST_REPEAT_VALUES = Object.freeze({
  dont_loop: 1,
  times1: 1,
  times2: 2,
  times3: 3,
  times4: 4,
  times5: 5,
  times6: 6,
  times7: 7,
  times8: 8,
  times9: 9,
  times10: 10,
  indefinitely: -2,
  wait_for_video: -1,
  loop_until_touched: -3,
});
/**
 * Default playlist repeat value.
 * @type {number}
 */
const DEFAULT_PLAYLIST_REPEAT_VALUE = PLAYLIST_REPEAT_VALUES.wait_for_video;

export { DEFAULT_PLAYLIST_REPEAT_VALUE, PLAYLIST_REPEAT_VALUES };
